export enum SnLayerType {
  Internal = 'Internal',
  External = 'External',
  EsriQuery = 'EsriQueryLayer',
  EsriStream = 'EsriStreamLayer',
  GeoJSON = 'GeoJSONLayer',
  Integration = 'Integration',
  InternalGeoJSON = 'Internal GeoJSONLayer',
  SomaGlobal = 'SomaGlobal',
}
